import DimensionListDetails from './DimensionListDetails';

export default DimensionListDetails;
